import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';
import { UserListDialogData } from 'src/app/models/user-list-dialog.model';

@Component({
  selector: 'app-user-list-dialog',
  templateUrl: './user-list-dialog.component.html',
  styleUrl: './user-list-dialog.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatDialogTitle, MatDialogContent],
})
export class UserListDialogComponent {
  protected readonly data = inject<UserListDialogData>(MAT_DIALOG_DATA);
}
